import { Box } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import CustomStepper from "../../customstepper/customStepper"
import Layout from "../Layout"

const PGM_LOGO_URL = "https://pgm-media.fteledition.fr/Uploads/78a72ac3-4f51-4269-ae23-093bf3516914/Fichier_1Mi_blanc.png"
const TROPHY_URL = "https://pgm-media.fteledition.fr/Uploads/c6fdac51-bc34-4048-ae73-b7e6869fd63f/ChatGPT_Image_26_janv._2026__15_52_01_removebg_preview.png"
const RUGBY_URL =
  "https://pgm-media.fteledition.fr/Uploads/166a0af6-5f69-4261-ba5e-ce45bf45afa5/gemini_3_pro_image_preview_a_Je_veux_une_illustra_removebg_preview.png"
const FOOT_URL =
  "https://pgm-media.fteledition.fr/Uploads/4a60a8cb-00f5-4b3c-8de3-5fb8daba6728/vecteezy_classic_black_and_white_3d_rendered_soccer_ball_isolated_on_73557060.png"

const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: "100vh",
    display: "grid",
    gridTemplateColumns: "70vw 30vw",
    overflow: "hidden",
    backgroundColor: "#353535",
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "1fr",
    },
  },
  visualPanel: {
    minHeight: "100vh",
    overflow: "hidden",
    position: "relative",
    backgroundColor: "#353535",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  visualLogo: {
    position: "absolute",
    display: "block",
    userSelect: "none",
    pointerEvents: "none",
  },
  pgmLogo: {
    width: 360,
    maxWidth: "48%",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
  },
  trophyLogo: {
    width: 92,
    right: "15%",
    top: "7%",
  },
  rugbyLogo: {
    width: 95,
    right: "8%",
    bottom: "16%",
  },
  footLogo: {
    width: 130,
    left: "7%",
    bottom: "7%",
  },
  formPanel: {
    minHeight: "calc(100vh - 12px)",
    backgroundColor: "#fff",
    borderTopLeftRadius: "6px",
    borderBottomLeftRadius: "6px",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      minHeight: "100vh",
      margin: 0,
      borderRadius: 0,
    },
  },
  formInner: {
    height: "100%",
    padding: theme.spacing(0, 1),
  },
}))

function HomePage() {
  const classes = useStyles()

  return (
    <Layout title={"Créez votre plateforme !"}>
      <Box className={classes.page}>
        <Box className={classes.visualPanel}>
          <img className={`${classes.visualLogo} ${classes.pgmLogo}`} src={PGM_LOGO_URL} alt='Pronostic Games' />
          <img className={`${classes.visualLogo} ${classes.trophyLogo}`} src={TROPHY_URL} alt='' />
          <img className={`${classes.visualLogo} ${classes.rugbyLogo}`} src={RUGBY_URL} alt='' />
          <img className={`${classes.visualLogo} ${classes.footLogo}`} src={FOOT_URL} alt='' />
        </Box>

        <Box className={classes.formPanel}>
          <Box className={classes.formInner}>
            <CustomStepper />
          </Box>
        </Box>
      </Box>
    </Layout>
  )
}

export default HomePage
